import { z } from "zod";

const targetIdSchema = z.string().uuid();
export const AGENT_ACCESS_GRANT_TARGET_ID_LIMIT = 50;

export const AgentAccessGrantTargetSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("all"),
    }),
    z.object({
        type: z.literal("organizations"),
        organizationIds: z
            .array(targetIdSchema)
            .min(1)
            .max(AGENT_ACCESS_GRANT_TARGET_ID_LIMIT),
    }),
    z.object({
        type: z.literal("workspaces"),
        workspaceIds: z
            .array(targetIdSchema)
            .min(1)
            .max(AGENT_ACCESS_GRANT_TARGET_ID_LIMIT),
    }),
]);

export type AgentAccessGrantTarget = z.infer<
    typeof AgentAccessGrantTargetSchema
>;

export const AgentAccessGrantTargetOrLegacyWorkspaceSchema = z.object({
    grantTarget: AgentAccessGrantTargetSchema.optional(),
    workspaceId: z.string().uuid().nullable().optional(),
});
